import Checkbox from "components/checkbox/Checkbox";
import messages from "messages";
import moment from "moment-timezone";
import ForwardedTimeSlotDropdown from "../../../calendar-view/components/interval-editor/components/time-slot-dropdown/TimeSlotDropdown";
import styles from "./AvailabilityScheduleDay.module.scss";

type Props = {
  dateValue: number;
  dayTitle: string;
  intervals: ParsedAvailableTimePeriod["intervals"][number] | null;
  timezone: TimeZone;
  onChange: (arg: ParsedAvailableTimePeriod["intervals"][number]) => void;
};

const EMPTY_TIME_SLOT: ScheduleInterval = {
  start_time: "",
  end_time: "",
};

/**
 * renders UI for editing available hours for each day
 */
const AvailabilityScheduleDay = ({
  dateValue,
  dayTitle,
  intervals,
  timezone,
  onChange,
}: Props) => (
  <div className={styles.container}>
    <Checkbox
      className={styles.checkbox}
      onChange={(e) => {
        const date = moment(dateValue).tz(timezone);
        onChange(
          e.target.checked
            ? [
                {
                  start_time: date.clone().hour(9).toISOString(),
                  end_time: date.clone().hour(17).toISOString(),
                },
              ]
            : null,
        );
      }}
      checked={intervals !== null}
      label={dayTitle.toUpperCase()}
      aria-label={dayTitle}
      labelClassName={styles["checkbox-label"]}
    />
    <ul className={styles.intervals}>
      {(!intervals?.length ? [EMPTY_TIME_SLOT] : intervals).map(
        (interval, index) => {
          const startTime = !interval.start_time
            ? ""
            : moment(interval.start_time).tz(timezone);
          const endTime = !interval.end_time
            ? ""
            : moment(interval.end_time).tz(timezone);

          return (
            <li className={styles.interval} key={`interval-${index}`}>
              <ForwardedTimeSlotDropdown
                dateValue={dateValue}
                time={!startTime ? "" : startTime.toISOString()}
                onChange={(from) =>
                  onChange([
                    ...(intervals || []).slice(0, index),
                    {
                      start_time: from || interval.start_time,
                      end_time: !endTime
                        ? interval.end_time
                        : endTime.toISOString(),
                    },
                    ...(intervals || []).slice(index + 1),
                  ])
                }
                isFrom={true}
              />
              <div>{messages.to}</div>
              <ForwardedTimeSlotDropdown
                toggleClass={styles["interval-editor__toggle"]}
                dateValue={dateValue}
                time={!endTime ? "" : endTime.toISOString()}
                onChange={(to) =>
                  onChange([
                    ...(intervals || []).slice(0, index),
                    {
                      start_time: !startTime
                        ? interval.start_time
                        : startTime.toISOString(),
                      end_time: to || interval.end_time,
                    },
                    ...(intervals || []).slice(index + 1),
                  ])
                }
              />
            </li>
          );
        },
      )}
    </ul>
  </div>
);

export default AvailabilityScheduleDay;
